import getConfig from 'next/config';
import { isInWebView } from './mobile';

const {
  publicRuntimeConfig: { context: appContext },
} = getConfig();

export const isMobileApp = appContext === 'mobile-app';

export const isRunningOnBrowser = typeof window !== 'undefined';

export const isSafari =
  isRunningOnBrowser &&
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const getRunningApp = () => {
  if (isInWebView()) {
    return 'mobile';
  }

  return 'web';
};

export const getRunningPlatform = () => {
  if (isInWebView()) {
    if (navigator.platform === 'Android') {
      return 'android';
    }

    if (navigator.platform === 'iPhone' || navigator.platform === 'iPad') {
      return 'ios';
    }
  }

  return 'web';
};
